import { updateBotAi } from '../../domain/entities/botAi.js';
import { applyBotAiDecision } from '../../domain/entities/applyBotAiDecision.js';
import { ARAM_CONFIG } from '../../domain/map/aramRules.js';
import { defaultChampionVisionRadius } from '../../domain/vision.js';
import { alliedWaveFollowTarget } from '../../domain/entities/botWaveFollow.js';

function sampleLaneMove() {
  const blue = ARAM_CONFIG.spawnPlatforms.blue;
  const red = ARAM_CONFIG.spawnPlatforms.red;
  const bot = {
    team: 'blue',
    x: blue.x,
    z: blue.z,
    hp: 500,
    maxHp: 500,
    attackRange: 175,
    visionRadius: defaultChampionVisionRadius(),
    isDead: false
  };
  const farTurret = { team: 'red', x: 0, z: 41, isDead: false };
  const decision = updateBotAi(bot, [farTurret], { blueSpawn: blue, redSpawn: red }, 0.05);
  return {
    action: decision.action,
    targetX: decision.targetX,
    targetZ: decision.targetZ,
    spawnZ: blue.z,
    walksTowardEnemy: decision.action === 'move' && decision.targetZ < blue.z
  };
}

function sampleBotAttack() {
  const dummy = { id: 'dummy', team: 'red', isDead: false };
  const bot = {
    team: 'blue',
    y: 0,
    attackTarget: null,
    issueAttackCommand(target) {
      this.attackTarget = target;
      return true;
    }
  };
  applyBotAiDecision(bot, { action: 'attack', targetEntity: dummy });
  return { hasAttackTarget: bot.attackTarget === dummy };
}

function sampleWaveFollow() {
  const bot = {
    team: 'blue',
    x: 0,
    z: 50,
    hp: 500,
    maxHp: 500,
    attackRange: 175,
    visionRadius: 8,
    isDead: false
  };
  const wave = { id: 'm1', team: 'blue', type: 'minion_melee', x: 0, z: 20, isDead: false };
  const pads = {
    blueSpawn: ARAM_CONFIG.spawnPlatforms.blue,
    redSpawn: ARAM_CONFIG.spawnPlatforms.red
  };
  const decision = updateBotAi(bot, [wave], pads, 0.05);
  const target = alliedWaveFollowTarget(bot, [wave]);
  return {
    action: decision.action,
    followsWave: decision.action === 'move' && decision.targetZ === 20,
    hasWaveTarget: target !== null
  };
}

function sampleCombatBot() {
  return {
    team: 'blue',
    x: 0,
    z: 0,
    hp: 500,
    maxHp: 500,
    attackRange: 150,
    visionRadius: 8,
    isDead: false,
    type: 'champion',
    cooldowns: { Q: 0, W: 0, E: 0, R: 0 }
  };
}

function sampleLastDecision() {
  const pads = {
    blueSpawn: ARAM_CONFIG.spawnPlatforms.blue,
    redSpawn: ARAM_CONFIG.spawnPlatforms.red
  };
  const enemy = {
    id: 'e1',
    team: 'red',
    type: 'champion',
    x: 1,
    z: 0,
    hp: 500,
    maxHp: 500,
    isDead: false
  };
  const decision = updateBotAi(sampleCombatBot(), [enemy], pads, 0.05);
  return { lastDecision: { action: decision.action, slot: decision.slot ?? null } };
}

/**
 * Agent smoke: ARAM bot move / AA / wave-follow / last-decision (FID-BOT-01 / FID-BOT-24).
 */
export function attachBotLaneMoveHook(win) {
  if (!win) return;
  win.__debugBotLaneMove = sampleLaneMove;
  win.__debugBotAttack = sampleBotAttack;
  win.__debugBotWaveFollow = sampleWaveFollow;
  win.__debugBotAi = sampleLastDecision;
}
